import isEqual from "lodash/isEqual";

import { MasterRuleStatus } from "constants/rules";

const SynchronisedRuleFields = [
  "content",
  "criteria",
  "input_field",
  "quantity_raw_format",
  "unit_amount_raw_format",
];

const SynchronisedRuleSetFields = ["criteria", "input_field"];

export const isManagedRuleOutOfSync = (
  managedRule,
  masterRule,
  managedRuleSet,
  masterRuleSet,
) =>
  SynchronisedRuleFields.some(
    field => !isEqual(managedRule[field], masterRule[field]),
  ) ||
  (managedRuleSet &&
    masterRuleSet &&
    SynchronisedRuleSetFields.some(
      field => !isEqual(managedRuleSet[field], masterRuleSet[field]),
    ));

export const getMasterRuleStatus = (
  rule,
  masterRule,
  ruleSet,
  masterRuleSet,
) => {
  if (!masterRule) {
    return MasterRuleStatus.NOT_MANAGED;
  } else if (masterRule.is_deleted) {
    return MasterRuleStatus.DELETED;
  } else if (isManagedRuleOutOfSync(rule, masterRule, ruleSet, masterRuleSet)) {
    return MasterRuleStatus.OUT_SYNC;
  } else {
    return MasterRuleStatus.IN_SYNC;
  }
};
